import { Link, Typography } from "@mui/material";

export function ContactUsInvalidAuthentication() {
  return (
    <Typography color="error" variant="body2">
      {"Your login attempt was unsuccessful."}
      <br />
      {"If you do not have an account but would like to try us out, we're happy to help!"}
      <br />
      <Link underline="none" href="https://doit.com/contact">
        Contact us to get started
      </Link>
    </Typography>
  );
}
